import React from 'react';
import * as ReactNativeWeb from 'react-native-web';

// Define Platform detection
export const Platform = {
  OS: typeof window !== 'undefined' && typeof document !== 'undefined' ? 'web' : 'native',
  select: (obj: any) => {
    const platform = typeof window !== 'undefined' && typeof document !== 'undefined' ? 'web' : 'native';
    return obj[platform] || obj.default;
  }
};

let ReactNative: any;

if (Platform.OS === 'web') {
  ReactNative = ReactNativeWeb;
} else {
  // In a native environment, 'react-native' should be available.
  // If running in a development environment where 'react-native' might not be directly available for static analysis,
  // but is provided at runtime (e.g., by Metro bundler), we can defer the assignment.
  // For web, the alias in vite.config.mjs already handles this.
  // If this code is running in a truly native environment, require will work.
  try {
    ReactNative = require('react-native');
  } catch (e) {
    console.warn("Could not load react-native in native environment, using web fallbacks", e);
    // Provide the web fallbacks if react-native fails to load in a native-like environment
    ReactNative = {
      View: ({ children, style, ...props }: any) => <div style={style} {...props}>{children}</div>,
      Text: ({ children, style, ...props }: any) => <span style={style} {...props}>{children}</span>,
      TouchableOpacity: ({ style, onPress, ...props }: any) => <button style={style} onClick={onPress} {...props} />,
      ScrollView: ({ style, contentContainerStyle, ...props }: any) => <div style={{...style, ...contentContainerStyle, overflow: 'auto'}} {...props} />,
      Dimensions: { get: () => ({ window: { width: window.innerWidth, height: window.innerHeight } }) },
      KeyboardAvoidingView: ({ children, ...props }: any) => <div {...props}>{children}</div>,
      Image: ({ source, style, ...props }: any) => <img src={typeof source === 'object' ? source.uri : source} style={style} {...props} />,
      TextInput: ({ style, onChangeText, value, ...props }: any) => <input style={style} value={value} onChange={(e) => onChangeText?.(e.target.value)} {...props} />,
      ActivityIndicator: ({ size, color }: any) => (
        <div style={{ 
          border: `3px solid ${color || '#007bff'}`, 
          borderTop: '3px solid transparent', 
          borderRadius: '50%', 
          width: size === 'large' ? 40 : 20, 
          height: size === 'large' ? 40 : 20, 
          animation: 'spin 1s linear infinite' 
        }}></div>
      ),
      StatusBar: () => null,
      SafeAreaView: ({ children, style, ...props }: any) => <div style={{...style, padding: '10px'}} {...props}>{children}</div>,
      Alert: { 
        alert: (title: string, message?: string) => {
          if (message) {
            window.alert(`${title}\n\n${message}`);
          } else {
            window.alert(title);
          }
        }
      },
      StyleSheet: { 
        create: (styles: any) => styles,
        flatten: (styles: any) => styles,
      },
      Platform,
      FlatList: ({ data, renderItem, keyExtractor, contentContainerStyle, ListEmptyComponent }: any) => (
        <ScrollView contentContainerStyle={contentContainerStyle}>
          {data.length > 0 ? (
            data.map((item: any, index: number) => (
              <View key={keyExtractor(item, index)}>
                {renderItem({ item, index })} 
              </View>
            ))
          ) : (
            ListEmptyComponent && ListEmptyComponent()
          )}
        </ScrollView>
      ),
    };
  }
}

export const { 
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  Dimensions,
  KeyboardAvoidingView,
  Image,
  TextInput,
  ActivityIndicator,
  StatusBar,
  SafeAreaView,
  Alert,
  StyleSheet,
  FlatList,
} = ReactNative;
